const PLUGIN_NAME = 'nm-content';
const COMPONENT_PREFIX = 'nm_';

export { PLUGIN_NAME, COMPONENT_PREFIX };
